import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

const CollectionItem = styled.div`
  position: relative;
  width: 325px;
  height: 290px;
  background: ${({ theme }) => theme.bsBg36};
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  margin: 10px 0px;
  &:hover{
    box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.3);
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
  `}
`

const TopImage = styled.img`
  width: 100%;
  height: 208px;
`

const CollectionInfo = styled.div`
  position: relative;
  padding: 0px 16px;
`

const Avatar = styled.img`
  width: 70px;
  height: 70px;
  position: absolute;
  top: -45px;
  left: 16px;
`

const TotalInfo = styled.div`
  text-align: right;
  height: 44px;
`

const Num = styled.div`
  
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.bsText28};
  padding-top: 8px;  
`

const NumText = styled.div`
  font-weight: normal;
  font-size: 13px;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.bsText28};
  opacity: 0.7;
`

const CollectionTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.bsText28};
  margin-top: -6px;
`
export default function CollectionCard({collection}: {collection: any}) {
  const history = useHistory();
  const goCollection = () => {
    history.push(collection.urlName)
  }

  return(
    <CollectionItem onClick={() => goCollection()}>
      <TopImage src={collection.image}/>
      <CollectionInfo>
        <Avatar src={collection.avatar}/>
        <TotalInfo>
          <Num>{collection.total}</Num>
          <NumText>items</NumText>
        </TotalInfo>
        <CollectionTitle>{collection.title}</CollectionTitle>
      </CollectionInfo>
    </CollectionItem>
  )
}